import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Checkbox, ButtonLegacy } from '~/shared/components';
import { StyledFilter, StyledLabel, StyledItemCount } from './styled';
import { FilterType } from '~/features/productsList/models';

type FilterProps = FilterType & {
    changeHandler: (value: string[]) => void;
    attribute: string;
};

export const Filter = ({
    label,
    count,
    value,
    isRefined,
    changeHandler,
    isToggleButton,
}: FilterProps) => {
    const [isSelected, setIsSelected] = useState(isRefined);

    const toggleFacet = async (facetValue?: string[]) => {
        if (facetValue) {
            changeHandler?.(facetValue);
        }
    };

    const handleClick = (e: SyntheticEvent) => {
        if (isToggleButton) {
            setIsSelected(!isSelected);
            e.stopPropagation();
            toggleFacet(value);
        }

        return;
    };

    useEffect(() => {
        setIsSelected(isRefined);
    }, [isRefined]);

    const labelComponent = (
        <StyledLabel
            isToggleButton={isToggleButton}
            htmlFor={encodeURIComponent(label)}
            title={label}
        >
            {label}
            {!isToggleButton ? <StyledItemCount>({count})</StyledItemCount> : null}
        </StyledLabel>
    );

    return (
        <StyledFilter
            as={isToggleButton ? ButtonLegacy : 'div'}
            isToggleButton={isToggleButton}
            variant={isSelected ? 'primary' : 'secondary'}
            onClick={handleClick}
        >
            {!isToggleButton ? (
                <Checkbox
                    checked={isSelected}
                    id={encodeURIComponent(label)}
                    fillRow={true}
                    onChange={(e: SyntheticEvent) => {
                        setIsSelected(!isSelected);
                        e.stopPropagation();
                        toggleFacet(value);
                    }}
                    label={labelComponent}
                />
            ) : (
                labelComponent
            )}
        </StyledFilter>
    );
};